// extracted by mini-css-extract-plugin
export default {"loaderContainer":"searchForUser_loaderContainer__NdEgX","searchInputWrapper":"searchForUser_searchInputWrapper__Db9q7"};